import api from '@/api/user_roster'
import { errorHandler } from "../exports/error_management"
import { buildQuery } from '../exports/queryStringBuilder'
import axios from 'axios'
const state = {
    user_roster: null,
    drivers: [],
    items: [],
    items_not_paginated: [],
    pagination: null,
    filter : null,
    query : null,
}

const mutations = {
    set(state, payload) {
        state.items = payload
    },
    set_items_not_paginated(state, payload) {
        state.items_not_paginated = payload
    },
    delete(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
    set_vehicle(state, user_roster) {
        state.user_roster = user_roster
    },
    set_drivers(state, drivers) {
        state.drivers = drivers
    },
    updateFilter(state, payload) {
       
        state.filter = payload.filters;
        state.query = payload.query;
    }
   
}

const actions = {
    create(context, payload) {
        return api
            .create(payload)
            .then(() => {})
            .catch(err => {
                errorHandler(err)
            })
    },
    fetchById(context, id) {
        return api
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data: user_roster },
                    },
                }) => {
                    console.log('store vehecddddd', user_roster)
                    context.commit('set_vehicle', user_roster)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    fetchUsers(context) {
        //const driver_role_id = 2
        return api
            .fetchDrivers()
            .then(
                ({
                    data: {
                        success: {
                            data: { data: drivers },
                        },
                    },
                }) => {
                    /*  console.log('drivers', drivers)
                    drivers = drivers.filter(
                        x => !!x.roles.find(r => r.role_id == driver_role_id)
                    ) */
                    context.commit('set_drivers', drivers)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },

    fetch(context, payload) {
        console.log('payload-', payload)
        return api
            .fetch(payload.query, payload.page,payload.filters)
            .then(
                ({
                    data: {
                        success: { data: pag },
                    },
                }) => {
                    if(payload.page && payload.page > 0){
                        console.log('pag', pag)
                        let users = pag.data

                        context.commit('set', users)
                            //let pag = result.data.success.data
                        context.commit('set_pagination', {
                            page: pag.current_page,
                            pageSize: pag.per_page,
                            total: pag.total,
                        })
                    } else {
                        console.log('pag', pag)
                        let items = pag

                        context.commit('set_items_not_paginated', items)
                    }
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },

    update(context, payload) {
        console.log('update', payload)
        return api
            .update(payload.id, payload)
            .then(() => {})
            .catch(err => {
                errorHandler(err)
            })
    },
    delete(context, id) {
        return api
            .delete(id)
            .then(() => {
                context.commit('delete', id)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    async exportExcelCSV(context, {query_r,filter_r }) {
        try {
            query_r = query_r || '';
            filter_r = filter_r || '';
            console.log('filters are ',filter_r);
          const response = await  axios.get(`user-roster/export-excel-csv?q=${query_r}&` + buildQuery(filter_r),{
            responseType: 'blob'
        })
          const blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "user_roster.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          console.error("Error fetching request:", err);
        }
      },
      async upload(context, payload) {
        try {
            console.log('payload is --------',payload);
            const results = await axios.post(`user-roster/upload`, payload)
           
            if (!results) return result.data.success.data || result.data.error
           
            // return data
        } catch (err) {
            errorHandler(err)
        }
    },
    
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}